import { BaseService } from 'src/app/shared/services/base.service';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/feathers.service";
export class TemplateService extends BaseService {
    constructor(feathers) {
        super("template", feathers.app);
    }
}
TemplateService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TemplateService_Factory() { return new TemplateService(i0.ɵɵinject(i1.FeathersService)); }, token: TemplateService, providedIn: "root" });
